import React, { Component } from 'react';
import "./PlaybuzzPopup.scss"

class PlaybuzzPopup extends Component {
    constructor(props) {
        super();
        this.state = {}
    }
    componentDidMount() {
        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);
            js.id = id;
            js.src = `https://embed.playbuzz.com/sdk.js?t=${new Date().getTime()}`;
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', `playbuzz-sdk-${new Date().getTime()}`));
    }
    render() {
        return (
            <div className="pb-popup">
                <div className="playbuzz" data-id="15003862-c8a6-4c95-bc1f-09e99dabe616" data-show-share="false" data-show-info="false"></div>
            </div>
        );
    }
}

export default PlaybuzzPopup;



// WEBPACK FOOTER //
// ./src/Components/Helpers/Popup/PlaybuzzPopup.jsx